/**
 * CategoryListPresenter
 * --
 */
import React, { useEffect, useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Text,
  Table,
  InputFormTable,
  Information,
  Pagination,
  Tree,
  ModalLayout,
  DragAndDropB,
} from 'components';
import {
  Avatar,
  Button,
  Radio,
  DatePicker,
  Input,
  Select,
  Flex,
  Table as AntTable,
  Space,
} from 'antd';
import {
  FileOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';
import { downloadXlsx } from 'utils/XlsxDownloader';

const SORT_OPTIONS = [
  {
    label: '최근 등록상품이 위로',
    value: 'created_at-DESC',
    type: 'number',
  },
  {
    label: '최근 등록상품이 아래로',
    value: 'created_at-ASC',
    type: 'number',
  },
  {
    label: '최근 수정상품이 위로',
    value: 'updated_at-DESC',
    type: 'number',
  },
  {
    label: '최근 수정상품이 아래로',
    value: 'updated-ASC',
    type: 'number',
  },
  {
    label: '판매가 높은 상품이 위로',
    value: 'price-DESC',
    type: 'number',
  },
  {
    label: '판매가 높은 상품이 아래로',
    value: 'price-ASC',
    type: 'number',
  },
  {
    label: '상품명 가나다순',
    value: 'menu_name-ASC',
    type: 'string',
  },
  {
    label: '상품명 가나다역순',
    value: 'menu_name-DESC',
    type: 'string',
  },
];

const CategoryListPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    data,
    categoriesOrder,
    isOpened,
    modalData,
    modalType,
    onOpen,
    onChange,
    onSubmit,
    onDelete,
    onDrop,
    onUpdateOrder,
  } = props;
  /* ===== STATE ===== */
  const ITEMS_PER_PAGE = 10; // 페이지 당 항목 수
  const [treeData, setTreeData] = useState(data);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [tabKey, setTabKey] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [keyword, setKeyword] = useState(null);

  const [sortValue, setSortValue] = useState(null);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={'상품명'}
                options={[
                  { label: '상품명', value: '상품명' },
                  { label: '회원명', value: '회원명' },
                  { label: '전화번호', value: '전화번호' },
                ]}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
              <Button size="large" icon={<PlusOutlined />} />
            </>
          ),
        },
      ],
    },
    {
      label: '상품 구분',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'기본상품'}>기본상품</Radio>
                <Radio value={'세트상품'}>세트상품</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '상품 분류',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={[
                  { label: '대분류1', value: '대분류1' },
                  { label: '대분류2', value: '대분류2' },
                  { label: '대분류3', value: '대분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'대분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '중분류1', value: '중분류1' },
                  { label: '중분류2', value: '중분류2' },
                  { label: '중분류3', value: '중분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'중분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '소분류1', value: '소분류1' },
                  { label: '소분류2', value: '소분류2' },
                  { label: '소분류3', value: '소분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'소분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '상세분류1', value: '상세분류1' },
                  { label: '상세분류2', value: '상세분류2' },
                  { label: '상세분류3', value: '상세분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'상세분류 선택'}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '상품 등록일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '진열 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'진열함'}>진열함</Radio>
                <Radio value={'진열안함'}>진열안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '판매 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'판매함'}>판매함</Radio>
                <Radio value={'판매안함'}>판매안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  // 현재 페이지에 표시할 데이터 계산
  const paginatedData = selectedItem?.menus?.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const form = [
    {
      label: '카테고리 번호',
      form: [
        {
          input: <p>{selectedItem?.key}</p>,
        },
      ],
    },
    {
      label: '카테고리 명',
      form: [
        {
          input: (
            <>
              <Input
                count={{
                  show: true,
                  max: 20,
                }}
                placeholder="카테고리 명을 입력하세요."
                style={{ ...styles.form.input.large }}
                value={selectedItem?.product_category_name}
                onChange={(e) =>
                  setSelectedItem({
                    ...selectedItem,
                    product_category_name: e.target.value,
                  })
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '표시여부',
      form: [
        {
          input: (
            <>
              <Radio.Group
                onChange={(e) =>
                  setSelectedItem({
                    ...selectedItem,
                    is_show: e.target.value,
                  })
                }
                value={selectedItem?.is_show}
              >
                <Radio value={'Y'}>노출</Radio>
                <Radio value={'N'}>노출안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    ...(selectedItem?.shop_information_id !== 1
      ? [
          {
            label: '승인여부',
            form: [
              {
                input: (
                  <>
                    <Radio.Group
                      onChange={(e) =>
                        setSelectedItem({
                          ...selectedItem,
                          application_status: e.target.value,
                        })
                      }
                      value={selectedItem?.application_status}
                    >
                      <Radio value={'APPROVE'}>승인</Radio>
                      <Radio value={'APPLY'}>승인신청</Radio>
                      <Radio value={'REJECT'}>반려</Radio>
                    </Radio.Group>
                  </>
                ),
              },
            ],
          },
        ]
      : []),
  ];

  const col = [
    {
      title: '상품번호',
      key: 'menu_id',
      dataIndex: 'menu_id',
      width: 75,
      align: 'center',
    },
    {
      title: '상품명',
      key: 'menu_name',
      dataIndex: 'menu_name',
      width: 210,
      align: 'center',
      filterDropdown: ({ selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onPressEnter={() => confirm()}
            placeholder={`상품명 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                setKeyword(''); // 초기화 시 검색 텍스트 비우기
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '상품 설명',
      key: 'menu_content',
      dataIndex: 'menu_content',
      width: 540,
      render: (item) => (
        <p
          style={{
            fontSize: '0.87em',
            opacity: 0.9,
            lineHeight: 1.2,
            textAlign: 'justify',
          }}
        >
          {item}
        </p>
      ),
    },
    {
      title: '판매가',
      key: 'price',
      dataIndex: 'price',
      width: 120,
      align: 'center',
      render: (item) => stringToMoneyFormat(item, '원'),
    },
    {
      title: '수량',
      key: 'num',
      dataIndex: 'num',
      width: 110,
      align: 'center',
      render: (item) => stringToMoneyFormat(item, '개'),
    },
    {
      title: '상품 타입',
      key: 'type',
      dataIndex: 'type',
      width: 110,
      align: 'center',
      render: (item) => (
        <button
          style={{
            border: 'none',
            background: 'none',
            textDecoration: 'underline',
            color: '#1C6BFF',
            cursor: 'pointer',
          }}
        >
          {item}
        </button>
      ),
    },
  ];
  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */
  useEffect(() => {
    if (!isCreating) {
      setTreeData(data);
    }
  }, [data, isCreating]);

  const SortData = React.useMemo(() => {
    if (!selectedItem) return [];

    const { menus } = selectedItem;

    let data = [...menus];
    if (keyword) {
      data = data.filter((item) => item.menu_name.includes(keyword));
    }
    // 상품 정렬
    if (sortValue) {
      const split = sortValue.split('-');

      const findType = SORT_OPTIONS.find(
        (item) => item.value === sortValue,
      ).type;
      switch (split[1]) {
        case 'DESC':
          data = data.sort((a, b) => {
            if (findType === 'string') {
              b[split[0]]?.localeCompare(a[split[0]], 'ko');
            } else {
              return b[split[0]] - a[split[0]];
            }
          });
          break;
        case 'ASC':
          data = data.sort((a, b) => {
            if (findType === 'string') {
              a[split[0]]?.localeCompare(b[split[0]], 'ko');
            } else {
              return a[split[0]] - b[split[0]];
            }
          });
          break;
        default:
          break;
      }
    }

    return data.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      currentPage * ITEMS_PER_PAGE,
    );
  }, [sortValue, selectedItem, currentPage, keyword]);

  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>카테고리 목록</Title>
          </Col>

          <Col x={4}>
            <Content
              maxWidth={'100%'}
              padding={5}
              backgroundColor="none"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #70737C',
                borderColor: 'rgba(112, 115, 124, 0.2)',
              }}
            >
              <Button
                size="small"
                style={{
                  borderColor: 'var(--primary-color)',
                  color: 'var(--primary-color)',
                }}
                onClick={() => onOpen(isOpened, 'category')}
              >
                카테고리 추가 +
              </Button>
              <Button
                size="small"
                color="default"
                onClick={() => onOpen(isOpened, 'order')}
              >
                카테고리 순서/편집
              </Button>
            </Content>
            <Content maxWidth={'100%'} backgroundColor="none">
              <Tree
                data={treeData}
                icon={{
                  0: ({ collapsed }) =>
                    collapsed ? <FolderOutlined /> : <FolderOpenOutlined />,
                  1: () => <FileOutlined />,
                }}
                onSelect={(key, item) => {
                  if (item.key === key) setIsCreating(false);
                  setSortValue(null);
                  setCurrentPage(1);
                  setSelectedItem(item);
                }}
                onDeSelect={(key, item) => setSelectedItem(null)}
              />
            </Content>
          </Col>
          <Col x={20}>
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor="none"
              style={{
                borderLeft: '1px solid #70737C',
                borderColor: 'rgba(112, 115, 124, 0.2)',
              }}
            >
              {selectedItem ? (
                <Content maxWidth={'100%'} style={{ marginBottom: 40 }}>
                  <ul
                    style={{
                      display: 'flex',
                      alignItems: 'stretch',
                      width: '100%',
                      marginBottom: 10,
                    }}
                  >
                    {[{ label: '카테고리 설정', key: 1 }]?.map(
                      (_item, _index) => (
                        <li
                          key={`tab_${_index}`}
                          onClick={() => setTabKey(_item.key)}
                          style={{
                            border: '1px solid #000',
                            borderColor:
                              tabKey === _item.key ? '#000' : '#B6AEAE',
                            borderBottom:
                              tabKey === _item.key ? 'none' : '1px solid #000',
                            fontSize: 14,
                            fontWeight: tabKey === _item.key ? 600 : 400,
                            color: tabKey === _item.key ? '#000' : '#B6AEAE',
                            padding: '10px 20px',
                            cursor: 'pointer',
                            display:
                              isCreating && _item.key === 2
                                ? 'none'
                                : 'inline-block',
                          }}
                        >
                          {_item.label}
                        </li>
                      ),
                    )}
                    <li
                      style={{
                        flex: 1,
                        borderBottom: '1px solid var(--black-color)',
                      }}
                    ></li>
                  </ul>
                  {tabKey === 1 ? (
                    <>
                      {/* 카테고리 설정 */}
                      <Content
                        maxWidth={'100%'}
                        padding={0}
                        backgroundColor={'none'}
                      >
                        <Information
                          content={[
                            '탭별 카테고리 설정은 표시여부에 따라 메인 화면에 반영됩니다.',
                            '카테고리 설정은 최종적으로 [저장] 버튼을 클릭 후 반영됩니다.',
                            '카테고리 번호는 저장 후에 생성 됩니다.',
                            '카테고리에 맵핑 되는 상품은 추가/수정 가능합니다.',
                          ]}
                        />
                        <div style={{ marginTop: 10 }}>
                          <InputFormTable form={form} />
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Button
                            size="large"
                            type="primary"
                            style={{
                              background: 'var(--primary-color)',
                              width: 110,
                              marginTop: 40,
                              marginRight: 10,
                            }}
                            onClick={() =>
                              onSubmit('category', 'UPDATE', selectedItem)
                            }
                          >
                            {'변경사항 저장'}
                          </Button>
                          <Button
                            size="large"
                            style={{
                              width: 110,
                              marginTop: 40,
                            }}
                            onClick={() =>
                              onDelete(selectedItem?.product_category_id)
                            }
                          >
                            {'삭제'}
                          </Button>
                        </div>
                      </Content>
                      {/* 카테고리 설정 끝 */}
                    </>
                  ) : (
                    <>
                      {/* 카테고리 상품관리 */}
                      <Content
                        maxWidth={'100%'}
                        padding={0}
                        backgroundColor={'none'}
                      >
                        <ExpandableContainer borderRadius={4} padding={20}>
                          {formItem?.map((_item, _index) => (
                            <div
                              key={`form_${_index}`}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px 0px',
                              }}
                            >
                              <div
                                style={{
                                  width: 120,
                                  fontSize: 13,
                                  fontWeight: 400,
                                }}
                              >
                                <label>{_item.label}</label>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {_item.form?.map((_subitem, _subkey) => (
                                  <React.Fragment key={`input_${_subkey}`}>
                                    {_subitem.input}
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                          ))}
                        </ExpandableContainer>

                        {/* 검색/초기화 버튼 */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            marginTop: 48,
                          }}
                        >
                          <Button
                            size="large"
                            type="primary"
                            style={{
                              ...styles.button,
                              background: 'var(--primary-color)',
                            }}
                          >
                            검색
                          </Button>
                          <Button size="large" style={{ ...styles.button }}>
                            초기화
                          </Button>
                        </div>
                        {/* 검색/초기화 버튼 끝 */}
                      </Content>
                      {/* 카테고리 상품관리 끝 */}
                    </>
                  )}
                </Content>
              ) : (
                <div
                  style={{
                    height: 300,
                    marginBottom: 40,
                    background: '#FFFFFF',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <p style={{ fontSize: 25 }}>카테고리를 선택해주세요</p>
                </div>
              )}

              {/* 검색결과 */}
              <Content maxWidth={'100%'} borderRadius={4} padding={20}>
                <Flex justify="space-between" style={{ marginBottom: 12 }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <h4 style={{ fontSize: 14, fontWeight: 500 }}>
                      검색 결과 총{' '}
                      <span>{selectedItem?.menus?.length || 0}</span>건
                    </h4>
                  </div>
                  <Flex gap={10} align="center">
                    <Select
                      value={sortValue}
                      options={SORT_OPTIONS}
                      placeholder={'정렬옵션'}
                      onChange={(e) => setSortValue(e)}
                      style={{ width: 180 }}
                    />
                  </Flex>
                </Flex>
                {/* <Table
                  data={SortData}
                  pagination={false}
                  columns={col}
                /> */}
                <AntTable
                  size="small"
                  dataSource={SortData}
                  pagination={false}
                  columns={col}
                  scroll={{ x: 1400 }}
                />
                <Pagination
                  current={currentPage}
                  total={selectedItem?.menus?.length || 0}
                  pageSize={ITEMS_PER_PAGE}
                  onChange={handlePageChange}
                  style={{ marginTop: 40 }}
                />
              </Content>
              {/* 검색결과 끝 */}
            </Content>
          </Col>
        </Row>
      </Content>

      {/* 카테고리 추가 */}
      <ModalLayout
        type="modal"
        centered
        title={'카테고리 추가'}
        open={isOpened && modalType === 'category'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={500}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit(
                  'category',
                  modalData?.category?.product_category_id
                    ? 'UPDATE'
                    : 'CREATE',
                )
              }
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <div style={{ marginBottom: '20px' }}>
                  <Select
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="상위 카테고리 선택 (선택사항)"
                    value={modalData?.category?.parents_id}
                    onChange={(value) =>
                      onChange('parents_id', value, 'category')
                    }
                    options={[
                      { label: '상위 카테고리 없음', value: null },
                      ...(Array.isArray(data)
                        ? data
                            .filter(
                              (category) =>
                                !category.menus || category.menus.length === 0,
                            ) // 메뉴가 없는 카테고리만 필터링
                            .map((category) => ({
                              label: category.product_category_name,
                              value: category.product_category_id,
                            }))
                        : []), // data가 배열이 아닐 때 빈 배열로 처리
                    ]}
                  />
                </div>

                <div>
                  <Input
                    size="large"
                    count={{
                      show: true,
                      max: 20,
                    }}
                    placeholder="카테고리를 입력해주세요"
                    value={modalData?.category?.product_category_name}
                    onChange={(e) =>
                      onChange(
                        'product_category_name',
                        e.target.value,
                        'category',
                      )
                    }
                  />
                </div>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* 순서 편집 */}
      <ModalLayout
        type="modal"
        centered
        title={'메뉴 순서 편집'}
        open={isOpened && modalType === 'order'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={600}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button type="primary" onClick={() => onUpdateOrder()}>
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                {/* 메뉴 드래그 앤 드롭 */}
                <div>
                  <h1>Drag and Drop Categories</h1>
                  <DragAndDropB
                    items={categoriesOrder}
                    onDrop={onDrop}
                    render={(item) => <span>{item.product_category_name}</span>}
                  />
                </div>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default CategoryListPresenter;
